// src/app/core/interceptors/auth.interceptor.ts
import { HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, throwError, switchMap, catchError } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { AuthUtils } from '../auth/auth.utils';

export const authInterceptor: HttpInterceptorFn = (
  request: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<any>> => {
  const authService = inject(AuthService);
  const accessToken = authService.accessToken;

  const authReq = accessToken
    ? request.clone({ setHeaders: { Authorization: `Bearer ${accessToken}` } })
    : request;

  // Attach the bearer token to regular API requests; the refresh endpoint keeps the
  // existing refresh-handling branch below.
  if (!request.url.includes('/user/auth/refresh-token')) {
    return next(authReq);
  }

  return next(authReq).pipe(
    catchError(() => {
      if (accessToken && AuthUtils.isTokenExpired(accessToken)) {
        console.log('Access token expired, attempting to refresh');
        return authService.refreshToken().pipe(
          switchMap(res => {
            const newAccessToken = res.data?.data?.accessToken;
            const cloned = request.clone({
              setHeaders: { Authorization: `Bearer ${newAccessToken}` }
            });
            return next(cloned); // Retry original request
          })
        );
      }
    })
  );
};
